import { ModalDialog, Size, ComponentS } from '@laerdal/life-react-components';
import React, { useEffect, useState } from 'react';
import { Organization } from 'types';
import { i18n } from 'i18next';
import { ListAvailableOrganizations } from '../ListAvailableOrganization';
import styled from 'styled-components';

interface Props {
  i18next: i18n;
  isModalOpen: boolean;
  selected: Organization | undefined;
  availableOrganizations: Organization[];
  closeModal: () => void;
  onChangeOrganization: (organizationId: string) => Promise<any>;
}

const ModalContent = styled.div`
  max-height: 500px;
`;

export const ChangeOrganizationModal = ({ isModalOpen, selected, availableOrganizations, i18next, closeModal, onChangeOrganization }: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOrganization, setSelectedOrganization] = useState(selected?.id);

  useEffect(() => {
    if (selected?.id !== selectedOrganization) {
      setSelectedOrganization(selected?.id);
    }
    setIsLoading(false);
  }, [selected]);

  return (
    <ModalDialog
      contentOverflow='auto'
      isModalOpen={isModalOpen}
      submitAction={() => {
        closeModal();
      }}
      closeModalAndClearInput={() => {
        closeModal();
      }}
      closeAction={() => {
        closeModal();
      }}
      title={i18next.t('Change organization')}
      size={Size.Small}
      buttons={[
        {
          action: () => {
            closeModal();
          },
          text: i18next.t('Close'),
          variant: 'tertiary',
        },
        {
          action: () => {
            setIsLoading(true);
            onChangeOrganization(selectedOrganization!).finally(() => setIsLoading(false));
          },
          disabled: selectedOrganization === selected?.id,
          text: i18next.t('Continue'),
          variant: 'primary',
          loading: isLoading
        }
      ]}>
      <ModalContent>
        <p><ComponentS>{i18next.t('Select an option to continue')}</ComponentS></p>
        <ListAvailableOrganizations
          availableOrganizations={availableOrganizations}
          selectedOrgId={selectedOrganization}
          handleSelectedOrganization={(id: string) => setSelectedOrganization(id)}
        />
      </ModalContent>
    </ModalDialog>
  );
};
